/*
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2023-10-25 11:40:01
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-03-19 10:34:41
 * @FilePath: \community-backendf:\community-frontend\src\hooks\gtm.js
 * @Description: 
 * 专注挖坑填坑补坑跳坑各种坑
 */

import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/user'
import { useSystemStore } from '@/stores/system'
import { routerInstance } from '@/router'
import md5 from './md5'

const mappList = {
  screen_name: {
    home: 'Home',
    allCircles: 'AllCircles',
    myCircles: 'MyCircles',
    circle: 'CircleDetails',
    message: 'Message',
    post: 'Publish',
    thread: 'ThreadDetails',
    user: 'UserProfile',
    topic: 'Topic',
    topics: 'Topics',
    powerOfCommunity: 'PowerOfCommunity',
    poc: 'Poc Details'
  },
  thread_category: {
    '1' : 'Article',
    '2' : 'Moment',
    '3' : 'Feedback',
    '4' : 'Poll'
  }
}

export default function (event, params = {}, sensorType) {
    
  const userStore = useUserStore()  // 用户仓库
  const systemStore = useSystemStore()
  const { isApp, isWeb } = storeToRefs(systemStore)
  const { uid, userInfo } = storeToRefs(userStore)   // 用户id

  const mappingKey = ['screen_name', 'thread_category']
  if (!params['screen_name']) {
    params['screen_name'] = routerInstance.currentRoute.value.name
  }
  Object.keys(params).forEach(key => {
    if (mappingKey.includes(key)) {
      params[key] = mappList[key][params[key]] || params[key]
    }
  })
  if (uid.value) {
    params.user_id = md5.hexMD5(uid.value)
  }
  switch (import.meta.env.VITE_COUNTRY) {
    case 'CHINA':
      // 国内神策埋点系统
      if (window['sensorsDataAnalytic201505']) {
        window.bbsOneplusSensors = window['sensorsDataAnalytic201505'];
        if (sensorType === 'init') {
          window.bbsOneplusSensors?.init({
            server_url: import.meta.env.VITE_SENSOR,
            heatmap:{scroll_notice_map:'not_collect'},
            is_track_single_page:true,
            use_client_time:true,
            send_type:'beacon',
            show_log: false,
          });
          // 上报ssoid
          // window.bbsOneplusSensors.setProfile({ssoid: userInfo.value.ssoid})
          window.bbsOneplusSensors.registerPage({
            login_status: () => {
              return uid.value ? 'logged-in' : 'not-logged-in'
            }
          })
        } else {
          // 上报登录状态
          window.bbsOneplusSensors.track(event, {
            ...params
          })
        }
        window.bbsOneplusSensors.quick('autoTrack');
        
      }
      
      break
    case 'IN': // overseas 海外GTM
    case 'PARIS': // overseas 海外GTM
    case 'GLOBAL': // overseas 海外GTM
      window.dataLayer.push({ "event_parameters": null });
      window.dataLayer.push({
        event: 'ga4Event',  // 固定事件
        'event_name': event,
        'event_parameters': {
          ...params,
          'page_source': isApp.value ? 'h5' : isWeb.value ? 'pc' : 'mo'
        }
      })
    default:
  }
  
}